import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../lib/api";
import { toast } from "sonner";
import { Button } from "../../components/ui/button";
import { Empty } from "../../components/founder/ui";
import { Check } from "lucide-react";

export default function FollowUps() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  const load = () => api.get("/follow_ups").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const complete = async (f) => {
    await api.patch(`/follow_ups/${f.id}`, { done: true });
    toast.success("Marked done");
    load();
  };

  const today = new Date().toISOString().slice(0, 10);

  return (
    <div className="p-5 md:p-8 max-w-4xl">
      <h1 className="font-serif text-3xl md:text-4xl text-lr-charcoal mb-6">Follow-ups</h1>
      {items.length === 0 ? <Empty>No open follow-ups.</Empty> : (
        <div className="space-y-3">
          {items.map((f) => {
            const overdue = (f.due_date || "9999") < today;
            const due = (f.due_date || "9999") <= today;
            return (
              <div key={f.id} className="lr-card p-4 flex items-center gap-4" data-testid={`followup-${f.id}`}>
                <button onClick={() => complete(f)} data-testid={`followup-done-${f.id}`}
                  className="h-8 w-8 rounded-full border border-lr-olive/40 flex items-center justify-center hover:bg-lr-olive hover:text-lr-cream transition-colors flex-shrink-0">
                  <Check className="h-4 w-4" />
                </button>
                <div className="flex-1 min-w-0">
                  <div className="text-lr-charcoal">{f.reason || "Follow up"}</div>
                  <button onClick={() => navigate(`/app/businesses/${f.business_id}`)} className="text-sm text-lr-clay hover:underline">
                    {f.business_name}
                  </button>
                </div>
                <span className={`text-sm ${overdue ? "text-lr-rose font-medium" : due ? "text-lr-clay" : "text-lr-leather"}`}>
                  {f.due_date || "No date"}{overdue ? " · overdue" : ""}
                </span>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
